/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.23.2
 * @since 1.23.2
 */

import { IProductResponse } from '../tariffsAndServicesProductTypes';
import { IProductsCategory, IProductsMeta } from '../tariffsAndServicesTypes';

export const calculateOtherCategory = (
    dataList: IProductResponse,
    productCategories: IProductsCategory[],
    productsMeta: IProductsMeta,
): IProductResponse => {
    const result = { ...dataList };
    if (!productCategories.length) return result;

    // получаем массив id всех категорий продуктов
    const categoryIds = productCategories.map((el) => el.id);

    if (dataList.tariffs.length) {
        dataList.tariffs.map((el) => {
            // находим пересечение поля groups для каждого тарифа и массива id категорий продуктов
            const intersectionArray = el.groups.filter(
                (el) => el !== productsMeta.tariffsCategoryId && categoryIds.includes(el),
            );
            // если пересечений нет - значит тариф не относится ни к одной категории,
            // помещаем его в категорию "Остальные тарифы", добавлением id этой категории в поле groups
            if (!intersectionArray.length) {
                el.groups.push(productsMeta.otherRatePlanCategoryId);
            }
            return el;
        });
    }

    return result;
};
